import React from 'react';
import { AutoComplete } from 'antd';
import type { AutoCompleteProps } from 'antd';
import { AntdFormItem } from '@/components/AntdForm/AntdFormItem.tsx';
import type { AntdFormItemProps } from '@/components/AntdForm/AntdFormItem.tsx';

type AntdFormAutoCompleteProps = AutoCompleteProps & AntdFormItemProps;

export const AntdFormAutoComplete: React.FC<AntdFormAutoCompleteProps> = ({
  fieldProps,
  ...props
}) => (
  <AntdFormItem {...fieldProps}>
    <AutoComplete {...props} />
  </AntdFormItem>
);
